import './App.css';
import Home from './Components/Home';
import Impress from './Components/Impress';
import { HashRouter, Routes, Route } from 'react-router-dom';

function App() {

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/impressum" element={<Impress />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
